__turbopack_context__.v({
  "fallback": "CollateralPage-module-scss-module__o954VG__fallback",
  "page": "CollateralPage-module-scss-module__o954VG__page",
  "root": "CollateralPage-module-scss-module__o954VG__root",
  "skeleton": "CollateralPage-module-scss-module__o954VG__skeleton",
});
